module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"recompute":"Recompute premiums"},"fr":{"recompute":"Recalculer les primes"}}')
  delete Component.options._Ctor
}
